var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 -1 64 64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.934 41.132 31.894-31.886 14.918 14.922-31.895 31.886z",
    fill: "#ffce31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.3 4.6-1.9-1.9c-3.6-3.6-9.4-3.6-13.1 0l-6.5 6.5 15 15 6.5-6.5c3.6-3.6 3.6-9.5 0-13.1",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.782 13.31 4.1-4.102 14.92 14.92-4.1 4.101z",
    fill: "#93a2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.338 14.865 4.1-4.101 11.739 11.738-4.102 4.1z",
    fill: "#c7d3d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.9 41.1-6.5 17 4.5 4.5 17-6.5z",
    fill: "#fed0ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.3 61.1c-.9 2.4.3 3.5 2.7 2.6l8.2-3.1-7.7-7.7-3.2 8.2",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.89 41.175 27.86-27.86 4.95 4.95-27.86 27.86z",
    fill: "#ffdf85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.904 51.142 27.86-27.86 4.95 4.95-27.86 27.86z",
    fill: "#ff8736"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1de77eee121f4bea3da265202fb9e5eb.svg";
export { ForwardRef as ReactComponent };